module.exports = __webpack_public_path__ + "static/media/5DPO24.8fce5235.jpg";